import { Statistic as AntdStatistic, Avatar, Button, StatisticProps, Table, TableColumnsType } from 'antd'
import { useEffect, useMemo, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../utils/redux/store'
import { attemptGetStatistics } from '../../utils/redux/statisticsSlice'
import { attemptGetPlaylistsList, Playlist, PlaylistOrderBy } from '../../utils/redux/playlistsSlice'
import { OrderDirection } from '../../utils/dto.d'
import { attemptSearchSongs, ListSongsOrderBy, Song } from '../../utils/redux/songsSlice'
import { useNavigate } from 'react-router-dom'
import { HiMiniNoSymbol } from 'react-icons/hi2'
import { TableActions } from '../../components/PlaylistsTable'
import { getSongDuration } from '../../utils/tools'

export const apiBaseURL = process.env.REACT_APP_API_BASE_URL || 'undefined'

const playlistsBasicColumns: TableColumnsType<Playlist> = [
  {
    title: 'Poster',
    dataIndex: 'image',
    render: (value) => (
      <Avatar
        shape="square"
        src={`${process.env.REACT_APP_UPLOADED_BASE_URL}/playlists/${value}`}
        icon={<HiMiniNoSymbol />}
      />
    ),
    width: 80,
  },
  {
    title: 'Title',
    dataIndex: 'title',
  },
  {
    title: 'Views',
    dataIndex: 'viewCount',
  },
  {
    title: 'Songs',
    dataIndex: 'songsCount',
  },
  {
    title: 'Duration',
    render: (_, playlist) => {
      return getSongDuration(playlist.totalDuration)
    },
    width: 120,
  },
]

const songsBasicColumns: TableColumnsType<Song> = [
  {
    title: 'Artist',
    dataIndex: 'artist',
  },
  {
    title: 'Title',
    dataIndex: 'title',
  },
  {
    title: 'Play count',
    dataIndex: 'playCount',
    width: 120,
  },
]

const PLAYLISTS_PER_PAGE = 20
const SONGS_PER_PAGE = 20

export default function Statistic() {
  const dispatch = useAppDispatch()
  const { users, playlists, songs, notValidatedUsers, ordersWithoutPlaylist } = useAppSelector((state) => state.statistics)
  const { total: popPlaylistsTotal, playlists: popPlaylists } = useAppSelector((state) => state.playlists)
  const { total: popSongsTotal, songs: popSongs } = useAppSelector((state) => state.songs)
  const [ popPlaylistsPage, setPopPlaylistsPage ] = useState(1)
  const [ popSongsPage, setPopSongsPage ] = useState(1)
  
  useEffect(() => {
    dispatch(attemptGetStatistics())
  }, [])

  useEffect(() => {
    dispatch(
      attemptGetPlaylistsList({
        skip: (popPlaylistsPage - 1) * PLAYLISTS_PER_PAGE,
        limit: PLAYLISTS_PER_PAGE,
        oderBy: PlaylistOrderBy.VIEW_COUNT,
        oderDirection: OrderDirection.DESC,
      }),
    )
  }, [popPlaylistsPage])

  useEffect(() => {
    dispatch(
      attemptSearchSongs({
        skip: (popSongsPage - 1) * SONGS_PER_PAGE,
        limit: SONGS_PER_PAGE,
        oderBy: ListSongsOrderBy.PLAY_COUNT,
        oderDirection: OrderDirection.DESC,
      }),
    )
  }, [popSongsPage])

  const playlistsColumns: TableColumnsType<Playlist> = useMemo(() => {
    return [
      ...playlistsBasicColumns,
      {
        title: 'Action',
        key: 'action',
        width: 120,
        render: (_, playlist) => (
          <TableActions
            confirm={{
              title: `Are you sure you want to delete ${playlist.title} playlist?`,
            }}
            onEdit={() => {
              navigate(`/music/playlists/playlist-edit/${playlist._id}`)
            }}
          />
        ),
      },
    ]
  }, [])

  const navigate = useNavigate()

  console.log('popPlaylists', popPlaylists)
  console.log('popSongs', popSongs)
  
  return (
    <div className='content'>
      <AntdStatistic
        title="Amount of songs"
        value={songs}
      />
      <AntdStatistic
        title="Amount of playlists"
        value={playlists}
      />
      <AntdStatistic
        title="Amount of clients"
        value={users}
      />
      <AntdStatistic
        title="Not yet validated clients"
        value={notValidatedUsers}
      />
      <AntdStatistic
        title="New playlist orders"
        value={ordersWithoutPlaylist}
      />

      <div>
        <strong>Popular playlists</strong>
        <Button type='link' href={`${apiBaseURL}/playlists/popular/export`}>Export</Button>
      </div>
      <Table<Playlist>
        size={'small'}
        columns={playlistsColumns}
        rowKey={(playlist) => playlist._id}
        dataSource={Object.values(popPlaylists)}
        pagination={{
          total: popPlaylistsTotal,
          pageSize: PLAYLISTS_PER_PAGE,
          showSizeChanger: false,
          current: popPlaylistsPage,
          onChange: (page) => setPopPlaylistsPage(page),
        }}
      />

      <div>
        <strong>Popular songs</strong>
        <Button type='link' href={`${apiBaseURL}/song/popular/export`}>Export</Button>
      </div>
      <Table<Song>
        size={'small'}
        columns={songsBasicColumns}
        rowKey={(song) => song._id}
        dataSource={Object.values(popSongs)}
        pagination={{
          total: popSongsTotal,
          pageSize: SONGS_PER_PAGE,
          showSizeChanger: false,
          current: popSongsPage,
          onChange: (page) => setPopSongsPage(page),
        }}
      />
    </div>
  )
}
